module.exports = __webpack_public_path__ + "static/media/custom_sign.76d26a12.svg";